import { toast } from "react-toastify";
import { store } from "../store";
import { logout } from "../features/authSlice";

let isLoggingOut = false;

export const forceLogout = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  toast.error("Session Expired !!");
  store.dispatch(logout());
};


export const forceLogoutDuplicate = (msg:any) => {
  toast.error(msg);
  store.dispatch(logout());
};
